<template>
  <div>
    <div>
      <b-row>
        <b-col lg="6">
          <div style="text-align: center;">
            <span style="font-size: 20px; font-weight: 500; color: #46E0E5; text-shadow: 0 0 4px #46E0E5;">
              เหตุการ์ที่เกิดขึ้นวันนี้มากที่สุด
            </span>
          </div>
        </b-col>

        <b-col lg="6">
          <div>
            <span style="font-size: 20px; font-weight: 500; color: #46E0E5; text-shadow: 0 0 4px #46E0E5;">
              จำนวนเหตุการ์ทั้งหมดที่เกิดขึ้นวันนี้
            </span>
          </div>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
import {
  BRow, BCol,
} from 'bootstrap-vue'
// import axios from '@axios'
// import ModalPhase from '@/views/traffiscifi/detailfi/ModalGraphPhase.vue'

export default {
  // name: 'SVGAnimation',
  components: {
    BRow,
    BCol,

  },
  data() {
    return {
      // animate: false,
      iconColor: 'rgba(0, 228, 255, 0.5)',
      check: '',
    }
  },
  computed: {

  },
  beforeDestroy() {
    window.removeEventListener('resize', this.isSmallScreen)
  },
  mounted() {
    this.checkPhase()
    window.addEventListener('resize', this.isSmallScreen)
    this.interval = setInterval(() => {
      window.addEventListener('resize', this.isSmallScreen)
    }, 100000)
  },
  methods: {

    isSmallScreen() {
      return window.innerWidth <= 850
    },
  },
}
</script>

<style scoped lang="scss">

</style>
